<p data-cy="members-count" *transloco="let t; read: 'dod-members-count'">
  <accredible-icon icon="group" />
  <span>{{ membersCount() | signedNumber }}</span>
  <span> {{ t('verified_professionals') }} </span>
</p>
